/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

/**
 * @type {import('styled-components').IStyledComponent<'web', {
 *     $expandedHeight: string,
 *     $isCollapsed: boolean,
 * } & React.HTMLAttributes<HTMLDivElement> & React.RefAttributes<HTMLDivElement>>}
 */
export const Wrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== '$expandedHeight' && prop !== '$isCollapsed'
})`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${(props) => {
    if (props['$isCollapsed']) {
      return `
        flex: 0 0 calc(var(--cds-spacing-07));
      `;
    }
    if (props['$expandedHeight']) {
      const flexGrow = parseInt(props['$expandedHeight'], 10);
      return `
        flex: ${flexGrow} 1 0;
        min-height: 0;
      `;
    }
    return `
      flex: 1 1 auto;
      min-height: 0;
    `;
  }}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--cds-background);
  height: var(--cds-spacing-07);
`;

export const ClickableHeader = styled(Header)`
  cursor: pointer;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  padding-left: var(--cds-spacing-04);
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: var(--cds-spacing-03);
  padding-right: var(--cds-spacing-02);
`;

export const Title = styled.h3`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  margin: 0;
`;

export const TitleIcon = styled.span`
  margin-right: var(--cds-spacing-03);
  margin-left: calc(var(--cds-spacing-02) * -1);
`;

export const Content = styled.div`
  background-color: white;
  flex-grow: 1;
  min-height: 0;
`;
